export const SELECT_TEMA = "SELECT_TEMA";
export const SELECT_PRATICA = "SELECT_PRATICA";
export const SET_FILTER = "SET_FILTER";

export const SELECT_GRUPO = "SELECT_GRUPO";
export const SELECT_ATRIBUTO = "SELECT_ATRIBUTO";
export const SELECT_INDICADOR = "SELECT_INDICADOR";

export const FETCH_INDICADORES = "FETCH_INDICADORES";
export const FETCH_PRATICAS = "FETCH_PRATICAS";

export const FETCH_SERIE_HIST = "FETCH_SERIE_HIST";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const AUTH_CHECK = "AUTH_CHECK";

export const SELECT_PROPRIEDADE = "SELECT_PROPRIEDADE";
export const FETCH_PROPRIEDADES = "FETCH_PROPRIEDADES";
export const EDIT_CONJUNTO = "EDIT_CONJUNTO";
export const ADD_CONJUNTO = "ADD_CONJUNTO";
export const REM_CONJUNTO = "REM_CONJUNTO";

export const SELECT_ADM_PROPRIEDADE = "SELECT_ADM_PROPRIEDADE";
export const SET_RESULTADOS = "SET_RESULTADOS";

export const WAIT = "WAIT";
export const SELECT_PROPRIEDADE_ATUAL = "SELECT_PROPRIEDADE_ATUAL";
